/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function() {
    // watch for class changes on the add to cart button. if the class changes click the button again to toggle the cart drawer
    const addToCartButton = document.querySelector('.product__add-to-cart-button');

    if (addToCartButton) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    if (mutation.target.classList.contains('ajax-cart__toggle')) {
                        addToCartButton.click();
                    }
                }
            });
        });

        observer.observe(addToCartButton, { attributes: true });
    }
}());
